function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import { useState, useEffect } from 'react';
import { connect, useSelector } from 'react-redux';
import { cmsActions } from '../../reducers/cms.reducer';
import { modalActions } from '../../reducers/modal.reducer';
import { assetViewerActions } from '../../reducers/assetViewer.reducer';
import useHasPermission from '../../helpers/hooks/useHasPermission';
import Button from '../common/Button.react';
import Label from '../common/form/Label.react';
import Select from '../common/form/Select.react';
import Card from '../common/card/Card.react';
import CardHeader from '../common/card/CardHeader.react';
import CardBody from '../common/card/CardBody.react';
import AssetThumbnail from './AssetThumbnail.react';
import UploadImage from '../common/assets/UploadImage.modal';
import UploadFile from '../common/assets/UploadFile.modal';
import AccessRestricted from '../app/routing/AccessRestricted.react';
var Assets = function Assets(_ref) {
  var assetsAction = _ref.assetsAction,
    addModalAction = _ref.addModalAction,
    assetViewerIndexAction = _ref.assetViewerIndexAction;
  var index = useSelector(function (s) {
    return s.assetViewer.index;
  });
  var navigate = useNavigate();
  var filters = useSelector(function (s) {
    return s.assetViewer.filters;
  });
  var activeApiCalls = useSelector(function (s) {
    return s.app.activeApiCalls;
  });
  var _useState = useState([]),
    _useState2 = _slicedToArray(_useState, 2),
    assets = _useState2[0],
    setAssets = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isLoading = _useState4[0],
    setIsLoading = _useState4[1];
  useEffect(function () {
    setIsLoading(activeApiCalls.find(function (x) {
      return x.id === 'asset-viewer-index';
    }) ? true : false);
  }, [activeApiCalls]);
  useEffect(function () {
    assetsAction({});
    assetViewerIndexAction(_objectSpread({}, filters));
  }, []);
  useEffect(function () {
    setAssets(Object.values(index).filter(function (x) {
      return !filters.type || filters.type === x.type;
    }).sort(function (a, b) {
      return b.dateAdded.localeCompare(a.dateAdded);
    }));
  }, [index]);
  if (!useHasPermission('view-assets')) return /*#__PURE__*/React.createElement(AccessRestricted, null);
  return /*#__PURE__*/React.createElement("div", {
    className: "page__content"
  }, /*#__PURE__*/React.createElement("div", {
    className: "page__content--block"
  }, /*#__PURE__*/React.createElement(Card, {
    style: {
      width: 420
    }
  }, /*#__PURE__*/React.createElement(CardBody, null, /*#__PURE__*/React.createElement(Button, {
    label: "Add New Image",
    onClick: function onClick() {
      addModalAction({
        component: /*#__PURE__*/React.createElement(UploadImage, null)
      });
    },
    style: {
      width: '100%',
      marginBottom: 15
    },
    permission: "edit-assets"
  }), /*#__PURE__*/React.createElement(Button, {
    label: "Add New File",
    onClick: function onClick() {
      addModalAction({
        component: /*#__PURE__*/React.createElement(UploadFile, null)
      });
    },
    style: {
      width: '100%'
    },
    permission: "edit-assets"
  })))), /*#__PURE__*/React.createElement("div", {
    className: "page__content--block"
  }, /*#__PURE__*/React.createElement(Card, null, /*#__PURE__*/React.createElement(CardHeader, {
    title: "Assets"
  }), /*#__PURE__*/React.createElement(CardBody, null, /*#__PURE__*/React.createElement(Label, {
    label: "Asset Type"
  }), /*#__PURE__*/React.createElement(Select, {
    value: filters === null || filters === void 0 ? void 0 : filters.type,
    onChange: function onChange(_ref2) {
      var sValue = _ref2.sValue;
      assetViewerIndexAction(_objectSpread(_objectSpread({}, filters), {}, {
        type: sValue,
        page: 0
      }));
    },
    placeholder: "All Assets",
    options: [{
      sValue: null,
      sLabel: 'All Assets'
    }, {
      sValue: 'document',
      sLabel: 'Document'
    }, {
      sValue: 'image',
      sLabel: 'Image'
    }, {
      sValue: 'logo',
      sLabel: 'Logo'
    }, {
      sValue: 'pageIndexContact',
      sLabel: 'Section Contact Slide-out'
    }, {
      sValue: 'project-icon',
      sLabel: 'Posillico Project Icon'
    }, {
      sValue: 'silhouette',
      sLabel: 'Silhouette'
    }, {
      sValue: 'video',
      sLabel: 'Video'
    }]
  }), assets.map(function (x) {
    return /*#__PURE__*/React.createElement(AssetThumbnail, _extends({}, x, {
      onClick: function onClick(_ref3) {
        var assetID = _ref3.assetID;
        return navigate("/asset/".concat(assetID));
      },
      key: x._id
    }));
  }), /*#__PURE__*/React.createElement("div", {
    className: "asset-thumb",
    onClick: function onClick() {
      if (isLoading) return;
      assetViewerIndexAction(_objectSpread(_objectSpread({}, filters), {}, {
        page: filters.page + 1
      }));
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "asset-thumb__img"
  }, isLoading ? 'Loading...' : 'Load More'))))));
};
var mdtp = {
  assetsAction: cmsActions.assets,
  assetViewerIndexAction: assetViewerActions.index,
  addModalAction: modalActions.add
};
export default connect(null, mdtp)(Assets);